import React, {Component} from 'react';
import MaciekLogo from "./components/Logo/Logo";
import AboutMe from "./components/Mobile/AboutMe/AboutMe";
import Splatanie from "./components/Mobile/Splatanie/Splatanie";
import Cienie from "./components/Mobile/Cienie/Cienie";
import Contact from "./components/Mobile/Contact/Contact";
import Swiper from 'react-id-swiper';
import CienieKsiazka from './components/Mobile/CienieKsiazka/CienieKsiazka';

class App extends Component {
    constructor(props) {
        super(props)
        this.goNext = this.goNext.bind(this)
        this.goPrev = this.goPrev.bind(this)
        this.swiper = null
      }
      goNext() {
        if (this.swiper) this.swiper.slideNext()
      }
      goPrev() {
        if (this.swiper) this.swiper.slidePrev()
      }
    render() {
        const params = {
            grabCursor: true,
            autoHeight: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        };
        return (
            <div>
                <MaciekLogo/>
                <Swiper {...params} ref={node => {if(node) this.swiper = node.swiper }}>
                    <div>
                        <AboutMe clicked={this.goNext}/>
                    </div>
                    <div>
                        <CienieKsiazka />
                    </div>
                    <div>
                        <Splatanie />
                    </div>
                    <div>
                        <Cienie />
                    </div>
                    <div>
                        <Contact />
                    </div>
                </Swiper>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js